import { ComponentPropsWithoutRef } from 'react'

export const SubMenuIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12851_3505)">
      <path
        d="M6.66656 4L5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export function LoadingIcon({
  color = '#2464F6',
  className,
}: {
  color?: string
  className?: string
}) {
  return (
    <div role="status" className={className}>
      <svg
        className="w-4 h-4 animate-spin"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="10.5"
          cy="11"
          r="8.75"
          stroke={color}
          strokeOpacity="0.25"
          strokeWidth="3"
        />
        <path
          d="M19.25 11C19.25 6.16751 15.3325 2.25 10.5 2.25"
          stroke="#2464F6"
          strokeWidth="3"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  )
}
